import * as React from 'react';
import { ElementType } from '../LocalMenu/EDLocalMenu';
import EDLabelMenu from '../LocalMenu/EDLabelMenu';

interface IProps {
  children: ElementType;
  label: React.ReactNode;
  menuLabel?: string;
  selected?: number;
  disabled?: boolean;
}

const EDMenuText = (props: IProps) => {
  return (
    <EDLabelMenu
      menuLabel={props.menuLabel}
      selected={props.selected}
      clickableElement={onClick => (
        <span onClick={!props.disabled ? onClick : undefined}>
          {props.label}
        </span>
      )}
    >
      {props.children}
    </EDLabelMenu>
  );
};

export default EDMenuText;
